module.exports = __webpack_public_path__ + "static/img/image-004.fb2b46ff.jpeg";